import React, { useEffect, useRef } from 'react';
import './sections.scss';
import gsap from 'gsap';
import logo from '../../assets/logo.png';

function Hero({ heroRef }) {
  const headRef = useRef();
  const copyRef = useRef();
  const logoRef = useRef();
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.to('.animateUp', { stagger: 0.4, opacity: 1, y: 0, duration: 0.7 });
    });

    return () => ctx.revert();
  }, []);

  return (
    <section className="sections sections-hero" ref={heroRef}>
      <div className="sections__text sections-hero__text">
        <img className="animateUp" src={logo} alt="It starts with Intel Logo" ref={logoRef} />
        <h1 className="animateUp" ref={headRef}>
          A Better Future Starts Now
        </h1>
        <p className="animateUp" ref={copyRef}>
          Technology has always defined the future, but never more than right now. No matter what
          industry you are in—healthcare, retail, education, or communication—it is likely being
          shaped by technology in ways you may not realize. AI is one of the technologies driving
          the acceleration of human potential, achieving what was once thought impossible. In this
          series, we look at the most inspiring, impactful, and even unexpected ways people around
          the world are using technology to create a{' '}
          <span className="linebreak">better future.</span>
        </p>
      </div>
    </section>
  );
}

export default Hero;
